<template>
    <div id="officerTab" class="">
        <div class="actions text-end mb-2">
            <button class="btn btn-primary mt-2 me-2" @click.prevent="handleAddOfficer()">Add an Officer</button>
        </div>
        <div class="row px-3 py-2" v-for="(officer, officerIndex) in contactFullReport!.officers" :key="keyColumn">
            <div class="col-12 border-rounded-gray">
                <div class="ucheader">
                    <div class="left">
                        <span class="Title">Officer {{ officerIndex + 1 }}</span>
                    </div>
                    <div class="right">
                        <button class="btn btn-link confirm-remove"
                            @click.prevent="handleRemoveOfficer(officerIndex)">Remove</button>
                    </div>
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight: bold">POST Number <span
                                    class="requiredfieldasterisk">*</span></label>
                        </div>
                        <div class="right">
                            <span style="color: Red; visibility: hidden">Required</span>
                        </div>
                    </div>

                    <input type="text" class="form-control" v-model="officer.post_number" :required="true" />
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight: bold">Name</label>
                        </div>
                        <div class="right"></div>
                    </div>

                    <input type="text" class="form-control" v-model="officer.officer_name" />
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight: bold">Officer on Duty <span
                                    class="requiredfieldasterisk">*</span></label>
                        </div>
                        <div class="right">
                            <span style="color: Red; visibility: hidden">Required</span>
                        </div>
                    </div>
                    <SelectField v-model="officer.officer_on_duty" :select-items="contactsStore.getYesNoUnknown"
                        :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                    </SelectField>
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight: bold">Injury Severity <span
                                    class="requiredfieldasterisk">*</span></label>
                        </div>
                        <div class="right">
                            <span style="color: Red; visibility: hidden">Required</span>
                        </div>
                    </div>

                    <SelectField v-model="officer.officer_injury" :select-items="contactsStore.getInjurySeverity"
                        :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                    </SelectField>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        <div class="row d-flex align-items-center">
                            <div class="col-6 text-start">
                                <h4 class="mb-0">Weapons Used by Officer</h4>
                            </div>
                            <div class="col-6 text-end">
                                <button class="btn btn-primary"
                                    @click.prevent="addWeaponsUsedByOfficer(officer)">Add</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-5">Weapon Type</div>
                            <div class="col-5">Weapon Discharged</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row border" v-for="(weaponDetail, index) in officer.weapon_details" :key="keyColumn">
                            <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2 text-center">
                                <SelectField v-model="weaponDetail.weapon_type"
                                    :select-items="contactsStore.getOfficerWeaponType" :is-horizontal="false"
                                    :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                                </SelectField>
                            </div>
                            <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2 text-center">
                                <SelectField v-model="weaponDetail.weapon_discharged"
                                    :select-items="contactsStore.getWeaponDischarged" :is-horizontal="false"
                                    :is-required="true" :ref="(el) => { addValidatableComponent(el) }" :is-nullable-bool="true">
                                </SelectField>
                            </div>
                            <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-2 p-2 mt-1 text-end">
                                <button class="btn-close me-3" aria-label="Remove"
                                    @click.prevent="handleRemoveOfficerField(officerIndex, `weapon_details`, officer.weapon_details, index)"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        <div class="row d-flex align-items-center">
                            <div class="col-6 text-start">
                                <h4 class="mb-0">Use of Force</h4>
                            </div>
                            <div class="col-6 text-end">
                                <button class="btn btn-primary" @click.prevent="addUseOfForce(officer)">Add</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-5">Type of Force Used</div>
                            <div class="col-5">Subject(s) of Force</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row border" v-for="(forceDetailsData, forceDetailsIndex) in officer.force_details" :key="keyColumn">
                            <div :class="{ 'bg-light': isAlternatingRow(forceDetailsIndex) }" class="col-5 p-2 text-center">
                                <SelectField v-model="forceDetailsData.force_type"
                                    :select-items="contactsStore.getOfficerTypeOfForce" :is-horizontal="false" :ref="(el) => { addValidatableComponent(el) }">
                                </SelectField>
                            </div>
                            <div :class="{ 'bg-light': isAlternatingRow(forceDetailsIndex) }" class="col-5 p-2 text-center">
                                <SelectField v-model="forceDetailsData.directed_at" :select-items="getDirectedAt"
                                    :mode="'tags'" :is-required="true" :min="1" :max="getDirectedAt.length" :ref="(el) => { addValidatableComponent(el) }"></SelectField>
                            </div>
                            <div :class="{ 'bg-light': isAlternatingRow(forceDetailsIndex) }"
                                class="col-2 p-2 mt-1 text-end">
                                <button class="btn-close me-3" aria-label="Remove"
                                    @click.prevent="handleRemoveOfficerField(officerIndex, `force_details`, officer.force_details, forceDetailsIndex)"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="actions text-end mb-2"
            v-show="contactsStore.contactFullReport!.officers && contactsStore.contactFullReport!.officers.length > 0">
            <button class="btn btn-primary mb-2 me-2" @click.prevent="handleAddOfficer()">Add an Officer</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, defineExpose, ref } from "vue";
import { SelectItem } from "../../types";
import { useContactsStore } from "../../stores/contactsStore";
import SelectField from "../Misc/SelectField.vue";
import { ForceDetails, Officer, InjurySeverity, YesNoUnknown, WeaponDetails } from "./schema";
import { storeToRefs } from "pinia";
import useValidation from "../Misc/validationUtils";

export default defineComponent({
    name: "officer",
    components: {
        SelectField,
    },
    props: {},
    data() {
        return {};
    },
    setup(props) {
        
        const keyColumn = 'generated_id';
        const contactsStore = useContactsStore();
        var { contactFullReport } = storeToRefs(useContactsStore());

        contactsStore.fetchAges();
        const {validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray } = useValidation();

        return { contactsStore, contactFullReport, keyColumn, triggerValidation, validatableComponentArray, addValidatableComponent, resetValidatableComponentArray };
    },
    computed: {
        getDirectedAt(): SelectItem[] {
            let items = [] as SelectItem[];

            if (this.contactsStore.contactFullReport!.citizens == undefined) {
                return items;
            }

            for (let index = 0; index < this.contactsStore.contactFullReport!.citizens.length; index++) {
                items.push({ label: `Citizen ${index + 1}`, value: index, isDisable: false });
            }

            return items;
        },
    },
    methods: {
        isAlternatingRow(index: number): boolean {
            return index % 2 == 1;
        },
        handleRemoveOfficer(officerIndex: number) {
            this.resetValidatableComponentArray();

            this.contactsStore.contactFullReport!.officers!.splice(officerIndex, 1);
        },
        handleRemoveOfficerField(officerIndex: number, fieldName: string, array: any, index: number) {
            this.resetValidatableComponentArray();

            array.splice(index,1);
        },
        handleAddOfficer() {
            if (this.contactsStore.contactFullReport!.officers == undefined) {
                this.contactsStore.$patch((state) => {
                    state.contactFullReport!.officers = [] as Officer[];
                });
            }

            this.contactsStore.$patch((state) => {
                state.contactFullReport!.officers!.push({
                    officer_injury: {} as InjurySeverity,
                    officer_on_duty: {} as YesNoUnknown,
                    post_number: "",
                    weapon_details: undefined,
                    officer_name: undefined,
                    force_details: [] as ForceDetails[],
                } as Officer);
            });

            var body = document.body,
                html = document.documentElement;

            var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

            window.scrollTo({
                top: height,
                left: 0,
                behavior: "smooth",
            });
        },
        addWeaponsUsedByOfficer(officer: Officer) {
            if (officer.weapon_details == null) {
                officer.weapon_details = [] as WeaponDetails[];
            }

            officer.weapon_details.push({
                weapon_type: "",
                weapon_discharged: undefined,
            } as WeaponDetails);
        },
        addUseOfForce(officer: Officer) {
            if (officer.force_details == null) {
                officer.force_details = [] as ForceDetails[];
            }

            officer.force_details.push({
                directed_at: [],
                force_type: "",
            } as ForceDetails);
        },
    },
});
</script>
